import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { RANK_CONFIG } from 'services/RankalyzerVariables';

class Logout extends Component<any> {
  componentDidMount() {
    this.props.auth.logout('/');
  }
  render() {
    console.log("enter logout");

    return <Redirect to="/" />;
  }
}

export default Logout;
